import { render, staticRenderFns } from "./StandingOrders.vue?vue&type=template&id=326fefd3&scoped=true&"
import script from "./StandingOrders.vue?vue&type=script&lang=js&"
export * from "./StandingOrders.vue?vue&type=script&lang=js&"
import style0 from "./StandingOrders.vue?vue&type=style&index=0&id=326fefd3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326fefd3",
  null
  
)

export default component.exports